import { Switch } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import PublicRoute from "./routes/PublicRoute";
import PrivateRoute from "./routes/PrivateRoute";
import Auth from "./components/auth/Auth";
import ResetPassword from "./components/auth/pages/ResetPassword";
import checkAuth from "./components/auth/pages/CheckAuth";
import UpgradeAccess from "./components/auth/pages/UpgradeAccess";

import Home from "./components/home/Home";
import ApiSetting from "./components/settings/Api-setting";

import Users from "./components/users/Users";
import CreateUser from "./components/users/UserCreate";
import UserProfile from "./components/users/User-profile";

import Create from "./components/campaign/Create";
import CampaignEditor from "./components/campaign/CampaignEditor";
import AudioList from "./components/campaign/Audio/Audio-List";
import RenderProcess from "./components/campaign/Render/Render";
import VideoBackgroundModal from "./components/campaign/VideoBackgroundModal";
import ListScens from "./components/Templates/ListTemplates/List-Scenes";
// import EasySort from "./components/campaign/Easy-sort";

import ListLandingPage from "./components/landingpage/List-landingPage";
import EditLanding from "./components/landingpage/Edit-landing";

import Analytics from "./components/personalize/Analytics";
import Pesonalize from "./components/personalize/Pesonalize";

import Header from "./components/shared/Header";
import { Footer } from "./components/shared/Footer";
import NotFound from "./components/shared/404";
import DFY from "./components/shared/DFY";
import Support from "./components/shared/Support";
import Bonus from "./components/shared/Bonus";
import LeadCraftBonus from "./components/shared/LeadCraftBonus";
import Tutorials from "./components/shared/Tutorials";
import vidAgencykitai from "./components/shared/VidAgencykitai";
import Bump from "./components/shared/Bump";
import MasterClass from "./components/shared/MasterClass";
import AllTemplates from "./components/shared/AllTemplates";
import UploadAssets from "./components/shared/UploadAssets";
import CreateTemplate from "./components/shared/CreateTemplate";
import { useEffect } from "react";
import { getSubdomain } from "./helpers/helpers";
import { authActions } from "./store/auth";
import useHttp from "./hooks/use-http";
import { endPoints } from "./config/end-points";

const AppRouting = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user_roles = useSelector((state) => state.auth.roles);

  const dispatch = useDispatch();

  const {sendRequest: getProductRequest} = useHttp();

  var PERMITTED_DOMAIN = "http://localhost";
  /**
   * Receiving message from other domain
   */
  window.addEventListener('message', function(event) {
      if (event.origin === PERMITTED_DOMAIN) {
          //var msg = JSON.parse(event.data);
          // var msgKey = Object.keys(msg)[0];
          if (event.data) {
              localStorage.setItem("vidamaze_user", JSON.parse(event.data).vidamaze_user);
              localStorage.setItem("vidamaze_ezdata", JSON.parse(event.data).ezData);
              
          } else {
              localStorage.removeItem("vidamaze_user");
              localStorage.setItem("vidamaze_ezdata");
          }
      }
  });
  // console.log("hii here");

  const subdomain_name = useSelector(state => state.auth.product.subdomain_name);
  const meta_data = useSelector(state => state.auth.product.meta_data)
  // console.log(subdomain_name, meta_data);


  useEffect (() => {
    const productName = getSubdomain();

    if(subdomain_name && meta_data && subdomain_name !== undefined && meta_data !== undefined && subdomain_name !== null && meta_data !== null && subdomain_name !== "" && meta_data !== ""){
      
      return true;
    }

    console.log(productName);
    if(productName){
      getProductRequest({
        url: endPoints.fetchProduct + productName,
        method: 'GET',
        
      }, (data) => {
        // console.log(data.status,Object.keys(data.body).length,data.body);
        if(data.status === 200 && Object.keys(data.body).length > 0){
          dispatch(authActions.setProduct({product:data.body}));
        }
        
      }, (error) => {
        console.log(error);
      })
    }else{


      // let default_data = {
      //   "id": 3,
      //   "subdomain_name": "vidwise",
      //   // "subdomain_name": "vidcraftai",
      //   "user_id": 1,
      //   "meta_type": "subdomain",
      //   "meta_data": "{\"subdomainName\":\"vidwise\",\"subdomainDesc\":\"Vidcraft AI\",\"subdomainLogo\":\"https:\\u002F\\u002Fd37q3r06begyqi.cloudfront.net\\u002FVidAmaze\\u002Fusers\\u002F1\\u002Fimages\\u002FVSAILogoDarkBigV2.png\",\"subdomainFavicon\":\"https:\\u002F\\u002Fd37q3r06begyqi.cloudfront.net\\u002FVidAmaze\\u002Fusers\\u002F1\\u002Fimages\\u002FVWAIFaviconDark64px.png\"}",
      //   // "meta_data": "{\"subdomainName\":\"vidcraftai\",\"subdomainDesc\":\"Vidcraft AI\",\"subdomainLogo\":\"https:\\u002F\\u002Fd37q3r06begyqi.cloudfront.net\\u002FVidAmaze\\u002Fusers\\u002F1\\u002Fimages\\u002FVCAILogoDarkBig.png\",\"subdomainFavicon\":\"https:\\u002F\\u002Fd37q3r06begyqi.cloudfront.net\\u002FVidAmaze\\u002Fusers\\u002F1\\u002Fimages\\u002FVCAIFaviconDark.png\"}",
      //   "createdAt": "2024-01-01T13:00:56.000Z",
      //   "updatedAt": "2024-01-01T13:00:56.000Z"
      // };
      // default_data.meta_data = JSON.parse(default_data.meta_data);
      // dispatch(authActions.setProduct({product:default_data}));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {isAuthenticated && <Header />}
      <Switch>
        {/* Auth Routes */}
        <PublicRoute restricted={true} component={Auth} path="/login" exact />
        <PublicRoute
          restricted={true}
          component={Auth}
          path="/forgot_password"
          exact
        />
        <PublicRoute
          restricted={true}
          component={ResetPassword}
          path="/resetPassword"
          exact
        />

        <PublicRoute
          restricted={false}
          component={checkAuth}
          path="/checkAuth"
          exact
        />

        <PrivateRoute
          restricted={true}
          component={UpgradeAccess}
          path="/upgrade-access/:plan"
          exact
        />

        {/* Home page Routes */}
        <PrivateRoute component={Home} path="/" exact />
        <PrivateRoute component={Home} path="/dashboard" exact />
        <PrivateRoute component={Home} path="/dashboard/:page_no" exact />

        {/* Users Routes */}
        <PrivateRoute
          component={Users}
          user_roles={user_roles}
          path="/users"
          exact
        />

        <PrivateRoute component={UserProfile} path="/profile" exact />

        <PrivateRoute
          component={Users}
          user_roles={user_roles}
          path="/users/:page_no"
          exact
        />

        <PrivateRoute
          component={CreateUser}
          user_roles={user_roles}
          path="/users/edit/:user_id"
          exact
        />

        <PrivateRoute
          component={CreateUser}
          user_roles={user_roles}
          path="/create-user"
          exact
        />
        
        {/* Settings Routes */}
        <PrivateRoute component={ApiSetting} path="/settings" />

        {/* Campaign Routes */}

        <PrivateRoute component={Create} path="/create-campaign" exact />
        <PrivateRoute
          component={AudioList}
          path="/campaign/:camp_id/audio"
          exact
        />

        <PrivateRoute
          component={CampaignEditor}
          path="/campaign/:camp_id/edit"
          exact
        />

        <PrivateRoute
          component={Analytics}
          path="/campaign/analytics/:camp_id/"
          exact
        />

        <PrivateRoute
          component={ListScens}
          path="/campaign/:camp_id/list-templates"
          exact
        />

        <PrivateRoute
          component={VideoBackgroundModal}
          path="/campaign/:camp_id/video-gallery"
        />

        <PrivateRoute component={RenderProcess} path="/render/:camp_id" exact />

        {/* Personalize Routes */}

        <PrivateRoute
          component={Pesonalize}
          path="/video/view/:camp_id"
          exact
        />

        <PrivateRoute
          component={ListLandingPage}
          path="/select-landing/:camp_id"
          exact
        />

        <PrivateRoute
          component={EditLanding}
          path="/:camp_id/edit-landing"
          exact
        />

        {/* Menu Pages Routes */}

        <PrivateRoute
          component={Support}
          path="/support"
          exact
        />

        <PrivateRoute
          component={Tutorials}
          path="/tutorials"
          exact
        />

        <PrivateRoute
          component={Bonus}
          path="/bonus"
          exact
        />

        <PrivateRoute 
          component={LeadCraftBonus}
          path="/leadcraft"
          exact
        />

        <PrivateRoute 
          component={MasterClass} 
          path="/masterclass" 
          exact 
        />

        <PrivateRoute 
          component={vidAgencykitai} 
          path="/vidAgencykitai" 
          exact 
        />



        <PrivateRoute 
          component={Bump} 
          path="/bump" 
          exact 
        />

        <PrivateRoute 
          component={DFY} 
          path="/dfy"  
          exact 
        />

        <PrivateRoute
          component={AllTemplates}
          path="/alltemplates"
          exact
        />

        <PrivateRoute component={AllTemplates} path="/alltemplates/:page_no" exact />

        <PrivateRoute
          component={UploadAssets}
          path="/uploadAssets"
          exact
        />

        <PrivateRoute
          component={CreateTemplate}
          path="/create-template"
          exact
        />

        <PrivateRoute
          component={CreateTemplate}
          path="/template/edit/:template_id"
          exact
        />

        <PublicRoute component={NotFound} path="" />
        <PrivateRoute component={NotFound} path="" /> 

        
      </Switch>
      {isAuthenticated && <Footer />}
    </>
  );
};

export default AppRouting;
